(function ($) {
  $(document).ready(function () {
    // ********* Archive matieres *********
    $('.matieres__top-filters-copy input').change(function () {
      $id = $(this).attr('id');
      $('label[for=' + $id + ']').toggleClass('checked');
    });

    $('.show-filters-responsive').click(function (event) {
      event.preventDefault();
      $('.left-filters').addClass('left-filters--active');
    });

    $('#left-filters-responsive-validate').click(function (event) {
      event.preventDefault();
      $('.left-filters--active').removeClass('left-filters--active');
    });

    $('.left-filters__more').click(function (event) {
      event.preventDefault();
      $('.matieres__top-filters-copy__holder').addClass('top-copy-show');
      $('.overlay').addClass('show-overlay');
    });

    $('#left-filters-responsive-validate-top-copy').click(function (event) {
      event.preventDefault();
      $('.matieres__top-filters-copy__holder').removeClass('top-copy-show');
      $('.overlay').removeClass('show-overlay');
    });

    $current_page = 1;

    function ajaxCall(){
      $filters = $('#filters-form');
      $serializedDatas = $filters.serializeArray();
      $jsonDatas = JSON.stringify($serializedDatas);

      $.ajax({
        url: ajaxurl,
        method: 'POST',
        data: {
          form: $jsonDatas,
          page_num: $current_page,
          action: 'save'
        },
        success: function (response) {
          $('.matieres__list').hide();
          $('.matieres__list--ajax').html(response);
        }
      });
    }

    function isIE() {
      ua = navigator.userAgent;
      /* MSIE used to detect old browsers and Trident used to newer ones*/
      var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

      return is_ie;
    }

    $('#reset-filters').click(function(){
      if (isIE()) {
        $('#filters-form')[0].reset();
      }
    });

    $('#filters-form').on('reset', function (event) {
      window.$current_page = 1;

      setTimeout(function () {
        $('.matieres__top-filters label, .matieres__top-filters-copy label').removeClass('checked');
        ajaxCall();
      });
    });

    $('.detectChange').change(function(){
      window.$current_page = 1;
      ajaxCall();
    });

    $(document).on('click', '.page-numbers',function (e) {
      e.preventDefault();

      if($(this).hasClass('next')){
        window.$current_page = window.$current_page + 1;
      }
      else if($(this).hasClass('prev')){
        window.$current_page = window.$current_page - 1;
      }
      else{
        window.$current_page = parseInt($(this).text());
      }

      ajaxCall();
    });

  });
})(jQuery); // Fully reference jQuery after this point.

